import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  CardMedia,
  Box,
} from "@mui/material";
import React from "react";
import { convertToSentenceCase, getImageFolder } from "../Utils/utils";

export const ProductItemTableOrder = (props) => {
  const { name, description, price, imageUrl, onOpen, rows } = props;
  return (
    <Grid
      item
      xs={12}
      sm={rows ? rows : 6}
      md={rows ? rows : 4}
      lg={rows ? rows : 3}
      xl={rows ? rows : 3}
      sx={{ width: "100%" }}
    >
      <Card
        onClick={(e) => onOpen()}
        sx={{ maxHeight: "104px", height: "104px" }}
      >
        <Box sx={{ display: "flex", height: "100%" }}>
          <CardMedia
            component="img"
            image={`${getImageFolder()}/images/xxs_${imageUrl}`}
            alt={name}
            sx={{
              maxHeight: "90px",
              maxWidth: "90px",
              width: "auto",
              height: "auto",
              margin: "8px",
            }}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = `${getImageFolder()}/images/no-image-icon-6.png`;
            }}
          />
          <Box>
            <CardHeader
              title={convertToSentenceCase(name)}
              subheader={price > 0 ? `$${price.toFixed(2)}` : ""}
              titleTypographyProps={{ variant: "h6" }}
              sx={{
                padding: "0px",
                paddingRight: "16px",
                overflowY: "auto",
              }}
            />
            <CardContent
              sx={{
                padding: "0px",
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ overflowY: "auto" }}
              >
                {description
                  ? convertToSentenceCase(description.substring(0, 80))
                  : description}
              </Typography>
            </CardContent>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};
